import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const FileIcon = (props) => (
  <SvgIcon viewBox="0 0 16 16" {...props}>
    <path
      d="M8.78129 1.33325H3.99996C3.26663 1.33325 2.66663 1.93325 2.66663 2.66659V13.3333C2.66663 14.0666 3.26663 14.6666 3.99996 14.6666H12C12.7333 14.6666 13.3333 14.0666 13.3333 13.3333V5.88525C13.3333 5.53192 13.1926 5.19258 12.9426 4.94258L9.72396 1.72392C9.47396 1.47392 9.13463 1.33325 8.78129 1.33325ZM12.3333 5.99992H8.66663V2.33325L12.3333 5.99992Z"
      fill={props.sx?.color || '#9C9FA5'}
    />
  </SvgIcon>
);

FileIcon.propTypes = {
  sx: PropTypes.object,
};

export default FileIcon;
